module.exports = __webpack_public_path__ + "static/media/bg_desafios.682e3a0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg/bg_desafios.png
// module id = 459
// module chunks = 0